export class BaseDistinctIdProvider {
    constructor(environment) {
        this.userInfo = {
            uid: null,
            ru: 0,
            iu: 0
        };
        this.environment = environment;

        this.init();
    }

    init() {}
    getIdInfo() {}
    setActivatedUser() {}
}